import { defineComponent as r, openBlock as o, createBlock as l, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconArrowUpInCircle",
  __name: "IconArrowUpInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (s, t) => (o(), l(p(i), c(n, { "view-box": "0 0 24 24" }), {
      default: m(() => [...t[0] || (t[0] = [
        e("path", { d: "M17.834 17.834A8.25 8.25 0 1 0 6.167 6.166a8.25 8.25 0 0 0 11.667 11.668m1.06 1.06c-3.807 3.808-9.98 3.808-13.788 0s-3.808-9.98 0-13.788 9.98-3.808 13.788 0 3.808 9.98 0 13.788" }, null, -1),
        e("path", { d: "M12.75 7.757a.75.75 0 0 0-1.5 0v8.486a.75.75 0 0 0 1.5 0V7.757" }, null, -1),
        e("path", { d: "M15.056 11.359a.75.75 0 0 0 1.06-1.06l-3.232-3.233a1.25 1.25 0 0 0-1.768 0l-3.232 3.232a.75.75 0 1 0 1.06 1.06L12 8.304l3.056 3.056" }, null, -1),
        e("path", { d: "M16.116 10.298a.75.75 0 0 1-1.06 1.06L12.75 9.054v7.19a.75.75 0 1 1-1.5 0v-7.19L8.944 11.36a.75.75 0 0 1-1.06-1.06l3.232-3.233a1.25 1.25 0 0 1 1.768 0l3.232 3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
